export const getCustomerEmail = customer => customer?.primaryEmail || '';

const getClientsByEmailResults = response => {
    const results = response?.payload || [];

    return Array.isArray(results) ? results : [];
};

const createClientRow = customer => {
    const email = getCustomerEmail(customer);
    const name = [customer?.firstName, customer?.lastName].filter(Boolean).join(' ');

    return {
        ...customer,
        email,
        name,
        clientFullName: name,
        clientNumber: customer?.masterId,
        c360Id: customer?.c360Id,
        mobileNumber: customer?.primaryPhone,
        address: customer?.addresses?.[0]?.addressLine1,
    };
};

export const mapClientsByEmail = (response, email) =>
    getClientsByEmailResults(response)
        .filter(customer => getCustomerEmail(customer).trim().toLowerCase() === email)
        .map(createClientRow);